import {
  AUTOPAY_ENABLE,
  AUTOPAY_ENABLE_FAILURE,
  AUTOPAY_ENABLE_SUCCESS,
  AUTOPAY_ENABLE_VALIDATION_FAILURE,
  CANCEL,
  CANCEL_FAILURE,
  CANCEL_SUCCESS,
  CHANGE,
  CHANGE_FAILURE,
  CHANGE_INPUT,
  CHANGE_STEP,
  CHANGE_SUCCESS,
  CHANGE_VALIDATION_FAILURE,
  FETCH_STATUS,
  FETCH_STATUS_FAILURE,
  FETCH_STATUS_SUCCESS,
  RESET_AUTOPAY_STATE,
  RESET_CANCEL_CONFIRMATION,
  RESET_CONFIRMATION,
  RESET_REQUEST_STATUS,
  SET_IS_AMOUNT_DRAWER_OPEN,
  SET_IS_IN_AUTOPAY_FLOW,
  SET_IS_MODAL_OPEN,
  STOP,
  STOP_FAILURE,
  STOP_SUCCESS,
  UPDATE_AMOUNT,
  UPDATE_EMAIL_ALERT_SETTING_FAILURE,
  UPDATE_FORM_ERROR,
} from './constants';

export function autopayEnable({ body, loanNumber }) {
  return {
    payload: { body, loanNumber },
    type: AUTOPAY_ENABLE,
  };
}

export function autopayEnableFailure() {
  return { type: AUTOPAY_ENABLE_FAILURE };
}

export function autopayEnableSuccess({
  additionalPrincipal,
  beginDate,
  confirmationNumber,
  delayDays,
}) {
  return {
    payload: {
      additionalPrincipal,
      beginDate,
      confirmationNumber,
      delayDays,
    },
    type: AUTOPAY_ENABLE_SUCCESS,
  };
}

export function autopayEnableValidationFailure({ account, amount, bannerError }) {
  return {
    payload: { account, amount, bannerError },
    type: AUTOPAY_ENABLE_VALIDATION_FAILURE,
  };
}

export function cancel({ navigationType = 'navigate', needsNavigation }) {
  return {
    payload: { navigationType, needsNavigation },
    type: CANCEL,
  };
}

export function cancelFailure() {
  return { type: CANCEL_FAILURE };
}

export function cancelSuccess(cancelConfirmationNumber) {
  return {
    payload: { cancelConfirmationNumber },
    type: CANCEL_SUCCESS,
  };
}

export function change({ navigationType = 'navigate', requestBody }) {
  return {
    payload: { navigationType, requestBody },
    type: CHANGE,
  };
}

export function changeFailure() {
  return { type: CHANGE_FAILURE };
}

export function changeSuccess(confirmationNumber) {
  return {
    payload: { confirmationNumber },
    type: CHANGE_SUCCESS,
  };
}

export function changeValidationFailure({ account, amount, bannerError }) {
  return {
    payload: { account, amount, bannerError },
    type: CHANGE_VALIDATION_FAILURE,
  };
}

export function changeInput({ field, form, value }) {
  return {
    payload: { field, form, value },
    type: CHANGE_INPUT,
  };
}

export function changeStep(step) {
  return {
    payload: { step },
    type: CHANGE_STEP,
  };
}

export function fetchStatus() {
  return { type: FETCH_STATUS };
}

export function fetchStatusFailure({ error }) {
  return {
    payload: { error },
    type: FETCH_STATUS_FAILURE,
  };
}

export function fetchStatusSuccess(statusData) {
  return {
    payload: statusData,
    type: FETCH_STATUS_SUCCESS,
  };
}

export function resetAutopayState() {
  return { type: RESET_AUTOPAY_STATE };
}

export function resetCancelConfirmation() {
  return { type: RESET_CANCEL_CONFIRMATION };
}

export function resetConfirmation() {
  return { type: RESET_CONFIRMATION };
}

export function resetRequestStatus({ statusType }) {
  return {
    payload: { statusType },
    type: RESET_REQUEST_STATUS,
  };
}

export function setIsAmountDrawerOpen(value) {
  return {
    payload: { value },
    type: SET_IS_AMOUNT_DRAWER_OPEN,
  };
}

export function setIsModalOpen({ key, value }) {
  return {
    payload: { key, value },
    type: SET_IS_MODAL_OPEN,
  };
}

export function stop({ navigationType = 'navigate' }) {
  return {
    payload: { navigationType },
    type: STOP,
  };
}

export function stopFailure() {
  return { type: STOP_FAILURE };
}

export function stopSuccess(confirmationNumber) {
  return {
    payload: { confirmationNumber },
    type: STOP_SUCCESS,
  };
}

export function updateAmount({ amount }) {
  return {
    payload: { amount },
    type: UPDATE_AMOUNT,
  };
}

export function updateEmailAlertSettingFailure() {
  return { type: UPDATE_EMAIL_ALERT_SETTING_FAILURE };
}

export function updateFormError({ field, form, value }) {
  return {
    payload: { field, form, value },
    type: UPDATE_FORM_ERROR,
  };
}

export function setIsInAutopayFlow({ value }) {
  return {
    payload: { value },
    type: SET_IS_IN_AUTOPAY_FLOW,
  };
}
